import { Component } from "react"

/* Link */
import { NavLink } from "react-router-dom"

/* Components */
import Icon from "./Icon"

/* Constants */
import { menu } from "../constants"


/* How many sections stand in the bar itself — the rest open in the sheet above it */
const PRIMARY = 4


/* Component Mobile Tab — the bar at the bottom of a narrow screen */
class MobileTab extends Component {

    constructor() {
        super()

        this.state = {
            visible: false
        }
    }

    componentDidMount = () => {
        document.addEventListener("click", this.handleClickOutside, true)
    }

    componentWillUnmount = () => {
        document.removeEventListener("click", this.handleClickOutside, true)
    }

    /* Click Outside Handler */
    handleClickOutside = event => {

        if (this._bar && !this._bar.contains(event.target) && this._more && !this._more.contains(event.target)) {
            this.setState({ visible: false })
        }
    }

    render = () => {

        /* Fields */
        const { visible } = this.state

        /* The sections themselves, without the captions between them */
        const items = menu.data.filter(item => !item.section)

        const primary = items.slice(0, PRIMARY)
        const rest = items.slice(PRIMARY)

        return (
            <div className="mobile-menu-container">

                <div className="mobile-menu">

                    {primary.map((item, index) =>
                        <NavLink onClick={() => this.setState({ visible: false })} key={`${index}`} to={item.link} end={item.link === "/"} className="mobile-menu-item">
                            <Icon name={item.icon} size={21} />
                            <span>{item.text}</span>
                        </NavLink>
                    )}

                    <div ref={ref => this._more = ref} onClick={() => this.setState({ visible: !visible })} className={`mobile-menu-item ${visible ? "active" : ""}`}>
                        <Icon name="more" size={21} />
                        <span>Ещё</span>
                    </div>

                </div>

                <div ref={ref => this._bar = ref} className={`mobile-menu-bar ${visible ? "active" : ""}`}>

                    <div className="mobile-menu-bar-handle" />

                    {rest.map((item, index) =>
                        <NavLink onClick={() => this.setState({ visible: false })} key={`${index}`} to={item.link} className="mobile-menu-bar-item">
                            <div className="mobile-menu-bar-image">
                                <Icon name={item.icon} size={20} />
                            </div>
                            <span>{item.text}</span>
                        </NavLink>
                    )}

                </div>

            </div>
        )
    }
}

export default MobileTab
